<template>
    <div>
        <!-- Alert: No item found -->
        <b-alert
            variant="danger"
            :show="!isLoading && campaign === null"
        >
            <div class="alert-body">
                Paylaşım Bulunamadı
                <b-link
                    class="alert-link"
                    :to="{ name: 'campaign' }"
                >
                    Paylaşım Raporları
                </b-link>
                sayfasını görüntüle
            </div>
        </b-alert>
      

        <div>
            <loading-card v-if="isLoading"></loading-card>
            <b-card
                no-body
                class="invoice-preview-card invoice-preview border-danger"
                 v-else-if="campaign !== null"
            >
                <!-- Header -->
                <b-card-body class="invoice-padding pb-0">
                    <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
                        <!-- Header: Left Content -->
                        <div>
                            <div class="logo-wrapper d-flex justify-content-between">
                                <h3>
                                    Aktif <b>{{ platformName }}</b> Paylaşımı : 
                                    <span  class="text-primary">{{ campaign.campaign_name || 'Paylaşım Adı Bulunamadı' }}</span>
                                </h3>
                                <div class="mt-md-0 mt-2 d-flex align-items-center">
                                    <div class="invoice-date-wrapper justify-content-end">
                                        <p class="invoice-date-title">Başlangıç Tarihi:</p>
                                        <p class="invoice-date">
                                            {{ formatDate(campaign.start_date) || 'Tarih Yok' }}
                                        </p>
                                    </div>
                                    <div class="invoice-date-wrapper justify-content-end" v-if="campaign.end_date">
                                        <p class="invoice-date-title">Bitiş Tarihi:</p>
                                        <p class="invoice-date semibold">
                                            {{ formatDate(campaign.end_date) || 'Tarih Yok' }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            
                            <b-col
                                cols="12"
                                class="p-0"
                            >
                                <div>
                                    <table cellpadding="10">
                                        <tbody>
                                            <tr>
                                                <td class="pr-1">Link:</td>
                                                <td>
                                                    <span v-if="campaign.link">
                                                        <a :href="campaign.link" target="_blank" rel="noopener noreferrer">{{ campaign.link }}</a>
                                                    </span>
                                                    <span v-else>
                                                        Link Yok
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="pr-1">Kısa Link:</td>
                                                <td v-if="campaign.short_url">
                                                    <a :href="campaign.short_url" target="_blank" rel="noopener noreferrer">{{ campaign.short_url }}</a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="pr-1">Uzun Link:</td>
                                                <td v-if="campaign.short_data.long_url">
                                                    <a :href="campaign.short_data.long_url" target="_blank" rel="noopener noreferrer" style="word-break: break-word;">{{ campaign.short_data.long_url }}</a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </b-col>
                            
                        </div>

                    </div>
                </b-card-body>

                <!-- Spacer -->
                <hr class="invoice-spacing">

                <!-- Invoice Client & Payment Details -->
                <b-card-body
                    class="invoice-padding p-0"
                >
                    <b-row class="invoice-spacing">
                        <b-col
                            xl="12"
                            md="12"
                        >
                            <global-summary :type="3" vestingHide="true" :platform_id="platform" />
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-card>

            <!-- <apex-line-area-chart/>-->
            <b-spinner v-if="isLoading" class="mt-2" label="Yükleniyor..."></b-spinner>
            <echart-stacked-area
                v-else
                :link_type="bioKeyId"
                :platform_id="platform"
            />
            
            <b-spinner v-if="isLoading" class="mt-2" label="Yükleniyor..."></b-spinner>
            <b-tabs
                v-else-if="influencer"
                pills
                >
                <b-tab>
                    <template #title>
                    <feather-icon
                        icon="InfoIcon"
                        size="16"
                        class="mr-0 mr-sm-50"
                    />
                    <span class="d-none d-sm-inline">Geçmiş Paylaşımlar</span>
                    </template>
                    <campaign-list :tableColumns="tableColumns" :params="params" :addBtnShow="addBtnControl"></campaign-list>
                </b-tab>
            </b-tabs>

        </div>
    </div>
</template>


<script>
    import { BRow,BLink, BAlert,BBadge,BCardTitle, BCol, BCard, BCardHeader, BCardBody, BTab, BTabs,BButton,BSpinner } from 'bootstrap-vue';
    import LoadingCard from '@/layouts/components/isLoading.vue';
    import GlobalSummary from '@/components/GlobalSummary.vue';
    import CampaignList from '../campaign/Links.vue';
    import ApexLineAreaChart from '@/components/charts-components/ApexLineAreaChart.vue';
    import EchartStackedArea from '@/components/charts-components/EchartStackedArea.vue';
    export default {
        components: {
            BTab, 
            BTabs,
            BRow,
            BCol,
            BLink,
            BCard,
            BCardHeader,
            BCardBody,
            BAlert,
            BBadge,
            BButton,
            BCardTitle,
            BSpinner,

            LoadingCard,
            GlobalSummary,
            CampaignList,
            ApexLineAreaChart,
            EchartStackedArea
        },
        data() {
            return {
                campaign: null,
                isLoading : true,
                influencer: {},
                isActiveTab: {},
                tableColumns : [
                    { key: 'id', sortable: true },
                    { key: 'campaign_name', label: 'Paylaşım', sortable: true },
                    { key: 'created_date', label: 'Ekleme Tarihi', sortable: true },
                    { key: 'start_date',label:'Başlama Tarihi', sortable: false },
                    { key: 'end_date',label:'Bitiş Tarihi', sortable: false },
                    { key: 'event_count',label:'Ziyaret', sortable: false },
                    { key: 'cart_count',label:'Sepete Ekleme', sortable: false },
                    { key: 'order_count',label:'Sipariş Adedi', sortable: false },
                    { key: 'total_amount',label:'Sipariş Tutarı', sortable: false },
                    { key: 'status', label: 'Durum'},
                    { key: 'actions', label: 'Detay'},
                ],
                bioKeyId:null,
                params:{
                    filter:{
                        type: null,
                        platform_id:this.$route.params.platform_id
                    }
                },
                platform:this.$route.params.platform_id,
                platformName:null
                
            }
        },
        vcomputed: {
            addBtnControl() {
                return this.$store.state.user.userData.permissions?.includes('firma_paylasimi.bio_ekleyebilir_duzenleyebilir');
            }
        }, 
        methods: {
            getCampaign () {
                this.$http.get('/link', {
                    params: {
                        filter:{
                            status:1,
                            type: this.bioKeyId,
                            platform_id:this.platform
                        },
                        source: this.$route.name,
                    }
                }).then((response)=>{
                    if(response.data.success){
                        this.campaign=response.data.data.Links[0];
                    }
                })
            },
            getPlatform () {
                this.$http.get('/platforms', {
                    params: {
                        id:this.platform
                    }
                }).then((response)=>{
                    this.platformName = response.data.data[0].name;
                })
            },
            getLinkType () {
                
                this.isLoading=true
                this.$http.get('/link/type', {
                    params: {
                        key: this.$route.params.key
                    }
                }).then((response)=>{
                    if(response.data.success){
                        this.bioKeyId=response.data.data[0].id
                        this.params.filter.type=response.data.data[0].id
                    }
                })
                .finally(()=>{
                    this.isLoading=false;
                    this.getCampaign();
                })
            }
        },
        mounted () {
            this.getPlatform();
            this.getLinkType();
        }
    }
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>
<style lang="scss" scoped>

</style>